<template>
    <nav class="z-breadcrumbs">
        <ul
            class="z-breadcrumbs__list"
            itemscope=""
            itemtype="http://schema.org/BreadcrumbList">
            <li
                class="z-breadcrumbs__item"
                v-for="(item, index) in list"
                :key="index"
                itemprop="itemListElement"
                itemscope=""
                itemtype="http://schema.org/ListItem">
                <component
                    :is="defineComponent(item.url)"
                    :underlined="false"
                    :class="getLinkClass(item.url)"
                    :href="item.url"
                    :title="item.name"
                    itemscope=""
                    itemtype="http://schema.org/Thing"
                    itemprop="item">
                    <z-icon
                        v-if="isHomePage(item.url)"
                        name="link/home"
                        width="20"
                        height="20"></z-icon>
                    <span
                        v-else
                        v-html="item.name"
                        itemprop="name"
                    ></span>
                </component>
                <meta itemprop="position" :content="index + 1" />
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useGetter } from '@/composable/useGetter'

const props = defineProps({
    propsData: {
        type: Array,
        default: () => []
    }
})

const pathname = ref(window.location.pathname)
const { app } = useGetter(['app'])
const data = app.value.components.breadcrumbs

const getLinkClass = (link) => {
    return [
        'z-breadcrumbs__item-link',
        {
            'z-breadcrumbs__item-link--active': isCurrent(link)
        }
    ]
}
const isCurrent = (link) => {
    return link === pathname.value
}
const isHomePage = (link) => {
    return link === '/'
}

const list = computed(() => {
    if (props.propsData && props.propsData.length) {
        return props.propsData
    }
    return data
})

const defineComponent = (link) => {
    const isCurrentPage = isCurrent(link)
    return isCurrentPage ? 'span' : 'z-link'
}
</script>

<style lang="scss" src="./index.scss"></style>
